module.exports = __webpack_public_path__ + "static/media/Rove - Itinerary Headers - 22 March 2023.4b889b44.mp4";